const LOGIN = 'nibi_admin/auth/LOGIN';
const LOGOUT = 'nibi_admin/auth/LOGOUT';
const SET_USER = 'nibi_admin/auth/SET_USER';
const SET_USER_ID = 'nibi_admin/auth/SET_USER_ID';
const SET_TOKEN = 'nibi_admin/auth/SET_TOKEN';

const initialState = {
  authenticated: false,
  user: {},
  userId: '',
  token: ''
};

export default function reducer(state = initialState, action) {

  const payload = action.payload;

  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        authenticated: true
      };
    case LOGOUT:
      return {
        ...state,
        authenticated: false,
        user: {},
        userId: '',
        token: ''
      };
    case SET_USER:
      return {
        ...state,
        user: payload.user
      };
    case SET_USER_ID:
      return {
        ...state,
        userId: payload.userId
      };
    case SET_TOKEN:
      return {
        ...state,
        token: payload.token
      };
    default:
      return state;
  }

}

export function userLogin() {
  return { type: LOGIN };
}

export function userLogout() {
  return { type: LOGOUT };
}

export function setUser(payload) {
  return { type: SET_USER, payload };
}

export function setUserId(payload) {
  return { type: SET_USER_ID, payload };
}

export function setToken(payload) {
  return { type: SET_TOKEN, payload };
}
